module.exports = __webpack_public_path__ + "static/timeline1994-e1b3c8a01bbb2d4bebe8333a0af86fd3.jpeg";